import { createAction, props } from '@ngrx/store';
import {
  CreatePlanParams,
  GetPlanParams,
  GetPlanResponse,
  GetFilteredPlansParams,
  GetFilteredPlansResponse,
  UpdatePlanParams,
} from 'src/app/core/proto';

export enum PlansActionTypes {
  PlansGet = '[Plans] Plans Get',
  PlansGetSuccess = '[Plans] Plans Get Success',
  PlansGetFailure = '[Plans] Plans Get Failure',
  PlanGet = '[Plans] Plan Get',
  PlanGetSuccess = '[Plans] Plan Get Success',
  PlanGetFailure = '[Plans] Plan Get Failure',
  PlanDestroy = '[Plans] Plan Destroy',
  PlanSet = '[Plans] Plan Set'
}

export const actionPlansGet = createAction(
  PlansActionTypes.PlansGet,
  props<{ body: GetFilteredPlansParams }>()
);

export const actionPlansGetSuccess = createAction(
  PlansActionTypes.PlansGetSuccess,
  props<{ payload?: GetFilteredPlansResponse }>()
);

export const actionPlansGetFailure = createAction(
  PlansActionTypes.PlansGetFailure
);

export const actionPlanGet = createAction(
  PlansActionTypes.PlanGet,
  props<{ params: GetPlanParams }>()
);

export const actionPlanDestroy = createAction(
  PlansActionTypes.PlanDestroy
);

export const actionPlanGetSuccess = createAction(
  PlansActionTypes.PlanGetSuccess,
  props<{ payload?: GetPlanResponse }>()
);

export const actionPlanGetFailure = createAction(
  PlansActionTypes.PlanGetFailure
);

export const actionPlanSet = createAction(
  PlansActionTypes.PlanSet,
  props<{ payload?: CreatePlanParams | UpdatePlanParams }>()
);
